// @ts-nocheck
function extractPageData(html) {
  var scripts = html.querySelectorAll('script');
  for (var i = 0; i < scripts.length; i++) {
    var text = scripts[i].textContent || '';
    if (text.indexOf('__klProduct') === -1) continue;
    try {
      var w = {};
      (new Function('window', text))(w); // eslint-disable-line no-new-func
      return { klProduct: w.__klProduct || null, tlcProduct: w.__tlcProduct || null };
    } catch (_) {}
    break;
  }
  return null;
}

document.addEventListener('variant:update', function (e) {
  var resource = e.detail && e.detail.resource;
  var isMorphed = !!(e.detail && e.detail.data && e.detail.data.mainMorphed);

  // Regular variant switch: inventory is current, update both badge types
  if (!isMorphed && resource && window.__tlcProduct && window.__tlcProduct.inventory) {
    var qty = window.__tlcProduct.inventory[String(resource.id)];
    document.querySelectorAll('.preorder-badge, .pdp-pre-order').forEach(function (badge) {
      badge.style.display = (typeof qty !== 'undefined' && qty <= 0) ? '' : 'none';
    });
  }

  if (!isMorphed) return;

  requestAnimationFrame(function () {
    var html = e.detail.data.html;
    if (html) {
      var data = extractPageData(html);

      if (data && data.tlcProduct) {
        window.__tlcProduct = data.tlcProduct;
        // .preorder-badge is inside <main> — re-rendered by morph, no action needed
        // .pdp-pre-order may be outside <main> — update manually with new product inventory
        var variantId = String(data.tlcProduct.variant_id);
        var newQty = data.tlcProduct.inventory && data.tlcProduct.inventory[variantId];
        document.querySelectorAll('.pdp-pre-order').forEach(function (badge) {
          badge.style.display = (typeof newQty !== 'undefined' && newQty <= 0) ? '' : 'none';
        });
      }

      if (data && data.klProduct) {
        var learnq = window._learnq = window._learnq || [];
        learnq.push(['track', 'Viewed Product', data.klProduct]);
      }
    }
  });
});

// Review widgets can sit in any section, and on a colour switch the non-product sections refresh in the
// background after variant:update — so re-render only once variant-picker.js reports they all show the new product.
document.addEventListener('product:sections-refreshed', function () {
  requestAnimationFrame(function () {
    var selectors = [
      '#klaviyo-reviews-all',
      '#fulfilled-reviews-all',
      '#klaviyo-reviews-list',
      '#fulfilled-reviews-list',
      '#klaviyo-reviews-summary',
      '#fulfilled-reviews-summary',
      '#klaviyo-featured-reviews-carousel',
      '#fulfilled-featured-reviews-carousel',
      '.klaviyo-star-rating-widget',
      '.fulfilled-star-rating-widget',
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function (el) {
      el.replaceWith(el.cloneNode(false));
    });

    var klObj = window.klReviewsObject;
    if (klObj) klObj.renderWidgets();
  });
});
